import { cn } from '@/utils/cn'
import { copyToClipboard } from '@/utils/copyToClipboard'
import { SECOND_IN_MILLISECONDS } from '@vaultsfyi/common/constants'
import { useEffect, useRef, useState } from 'react'
import { LinkIcon } from '../icons/link'
import { Tooltip, TooltipContent } from './tooltip'

interface Props {
  sectionId: string
  className?: string
}

export function CopySectionLink({ sectionId, className }: Props) {
  const [copied, setCopied] = useState(false)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)

  useEffect(() => () => clearTimeout(timeoutRef.current), [])

  const handleClick = async () => {
    const { origin, pathname, search } = window.location
    window.location.hash = sectionId
    try {
      await copyToClipboard(`${origin}${pathname}${search}#${sectionId}`)
      setCopied(true)
      clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(() => setCopied(false), 2 * SECOND_IN_MILLISECONDS)
    } catch (error) {
      console.error('Failed to copy section link to clipboard', error)
    }
  }

  return (
    <Tooltip
      onClick={handleClick}
      className={cn(
        'rounded-full text-body-foreground/20 group-[&:target]:animate-glow-text group-[&:target]:text-body-foreground',
        className
      )}
    >
      <LinkIcon size={24} />
      <TooltipContent>{copied ? 'Copied!' : 'Copy link'}</TooltipContent>
    </Tooltip>
  )
}
